export default __webpack_public_path__ + "static/media/blog-posts.94323719.jpg";